// extracted by mini-css-extract-plugin
module.exports = {"table":"candidateTable_table__3tEMS","profileName":"candidateTable_profileName__2rjxH","cursor":"candidateTable_cursor__Ya98L"};